import Vue from 'vue';

const getImgParam = (name, str) => {
  if (!str) return null;
  const regExp = `(${name})=([0-9]+)`;
  const reg = new RegExp(regExp, 'i');
  const r = str.match(reg);
  if (r !== null) return r[2];
  return null;
};

const handleByImgSrc = function (el, binding, vnode) {
  if (!el) return;
  // 渲染宽度
  const renderWidth = el.getBoundingClientRect().width;
  // 2倍图宽度
  const boxWidth = renderWidth * 2;
  const src = el.src || (binding.value && binding.value.src);
  const ImgWidth = getImgParam('width', src);
  const ImgHeight = getImgParam('height', src);
  if (ImgWidth && ImgHeight) {
    // 计算出rem
    // el.style.width = window.pxToRem(boxWidth);
    const remValue = window.pxToRem((ImgHeight * boxWidth) / ImgWidth);
    // eslint-disable-next-line no-param-reassign
    el.style.height = remValue;
  }
};
Vue.directive('setImgHeight', {
  inserted: handleByImgSrc,
  update: handleByImgSrc,
});
